<template>
    <div>
        <Header></Header>

        <!-- Stories Section -->
        <div class="container space-2">
            <!-- Title -->
            <div class="w-md-80 w-lg-50 text-center mx-md-auto mb-5 mb-md-9">
                <h2 style="color:#377dff" >创联天成软件平台</h2>
            </div>
            <!-- End Title -->

            <div class="row">
                <div class="col-sm-6 col-md-4 mb-5" v-for="item in productList" :key="item.id">
                    <!-- Card Info -->
                    <div class="card h-100">
                        <img class="card-img-top" :src="getImgUrl(item.picture)" alt="Image Description">
                        <div class="card-body">
                            <div class=" w-100 mb-3">
                                <p class="hover-color" @click="skip(item)" style="font-size:20px;font-weight:550;cursor:pointer">{{item.title}}</p>
                            </div>
                            <el-row :gutter="16" >
                                <el-col :span="8" v-for="(ts,index) in item.productLinks.filter(h =>{return (h.link && h.link != null)}).sort((a,b)=>{return a.tag - b.tag})" :key="ts.id" class="hover-color" style="line-height:30px;cursor:pointer" :style="( index%3 == 2) ? 'text-align:right':(( index%3 == 1)?'text-align:center':'')"   > <span @click="skip(ts)">{{ts.name.substring(0,4)}}</span> </el-col>
                            </el-row>
                        </div>
                    </div>
                    <!-- End Card Info -->
                </div>
            </div>
        </div>
        <!-- End Stories Section -->

        <Footer></Footer>
    </div>
</template>

<script>
import '@/assets/vendor/jquery/dist/jquery.min.js'
import '@/assets/vendor/jquery-migrate/dist/jquery-migrate.min.js'

import '@/assets/vendor/font-awesome/css/all.min.css'
import '@/assets/vendor/hs-mega-menu/dist/hs-mega-menu.min.css'
import '@/assets/vendor/fancybox/dist/jquery.fancybox.min.css'
import '@/assets/vendor/aos/dist/aos.css'
import '@/assets/css/theme.css'
import '@/assets/vendor/hs-header/dist/hs-header.min.js'
import '@/assets/vendor/hs-go-to/dist/hs-go-to.min.js'
import '@/assets/vendor/hs-unfold/dist/hs-unfold.min.js'
import '@/assets/vendor/hs-mega-menu/dist/hs-mega-menu.min.js'
import '@/assets/vendor/fancybox/dist/jquery.fancybox.min.js'
import '@/assets/vendor/appear.js'
import '@/assets/vendor/circles/circles.min.js'
import '@/assets/vendor/polifills.js'
import AOS from 'aos'
// import 'aos/dist/aos.css'

// import 'bootstrap'
// import "bootstrap/dist/css/bootstrap.css";
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import '@/assets/js/hs.core.js'
import '@/assets/js/hs.fancybox.js'

import '@/assets/js/hs.circles.js'
import '@/assets/vendor/hs-counter/dist/hs-counter.min.js'
import Header from '../components/header'
import Footer from '../components/footer'
import moment from 'moment'
import { getProductList } from '../request/index'
export default {
    components: {
        Header,
        Footer,
    },

    mounted() {
        // window.addEventListener("scroll", this.handleScroll);
        $(document).ready(function () {
            //   console.log("ccccc",HSHeader)
            //   var header = new HSHeader($("#header")).init();

            // initialization of mega menu
            var megaMenu = new HSMegaMenu($('.js-mega-menu'), {
                desktop: {
                    position: 'left',
                },
            }).init()

            // initialization of unfold
            var unfold = new HSUnfold('.js-hs-unfold-invoker').init()

            // initialization of fancybox
            $('.js-fancybox').each(function () {
                var fancybox = $.HSCore.components.HSFancyBox.init($(this))
            })

            // initialization of circles
            $('.js-circle').each(function () {
                var circle = $.HSCore.components.HSCircles.init($(this))
            })

            //initialization of aos
            AOS.init({
                duration: 650,
                once: true,
            })
            // if (/MSIE \d|Trident.*rv:/.test(navigator.userAgent)) document.write('<script src="@/assets/vendor/polifills.js"><\/script>');
            // initialization of go to
            $('.js-go-to').each(function () {
                var goTo = new HSGoTo($(this)).init()
            })
            $('.js-counter').each(function () {
                var counter = new HSCounter($(this)).init()
            })
        })
    },
    data() {
        return {
            productList:[],
            page: 0,
            size: 9,
            total: null,
        }
    },
    created() {
        getProductList({page:0,size:999}).then(res=>{
            this.productList = res.data.content
        })
    },
    methods: {
       
        // 打开产品链接
        skip(obj) {
            console.log("跳转",obj)
            window.open(obj.link)
        },
        // 时间转换
        getTime(val) {
            return (
                moment(val).get('year') +
                ' 年 ' +
                (parseInt(moment(val).get('month')) + 1) +
                ' 月 ' +
                moment(val).get('date') +
                ' 日'
            )
        },
        // 图片地址
        getImgUrl(id){
            return process.env.NODE_URL + "api/files/getFileStream?fileId="+id
        },
    },
}
</script>

<style scoped>
.bg-img-hero {
    background: url('../assets/svg/components/abstract-shapes-5.svg') center;
}
.pb-5,
.py-5 {
    padding: 2rem 0 !important;
}
.text-dark {
    line-height: 1.6;
    color: #1e2022 !important;
}
.text-body {
    color: #677788 !important;
}
.mb-3 h4 {
    margin-bottom: 0.5rem;
    font-size: 1.125rem;
    font-weight: 600;
    line-height: 1.4;
}
.col-sm-12 h4 {
    font-size: 0.875rem;
    font-weight: 600;
    line-height: 1.4;
}
.col-sm-12 p {
    font-size: 0.875rem;
    color: #677788 !important;
}
#stickyBlockStartPoint {
    position: sticky !important;
    position: -webkit-sticky;
    top: 10px;
}
.pl-lg-4 .h3 {
    margin-bottom: 0.5rem;
    font-size: 1.3125rem;
    font-weight: 600;
    line-height: 1.4;
}
.pl-lg-4 p {
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.6;
    color: #677788;
}
.font-weight-normal {
    font-size: 1.875rem;
    line-height: 1.4;
}
.mx-lg-auto .mb-0 {
    font-size: 2.5rem;
    font-weight: 600;
    line-height: 1.4;
}
.text-muted {
    font-weight: 400;
    color: #8c98a4 !important;
    line-height: 1.6;
}
a {
    text-decoration: none;
}
.mb-md-9 h2 {
    font-size: 1.875rem;
    margin-bottom: 0.5rem;
    font-weight: 600;
    line-height: 1.4;
}
.card-body .mb-0 {
    font-size: 0.875rem;
    font-weight: 600;
    line-height: 1.6;
}
.card-body .mb-01 {
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.6;
}
.mx-lg-auto .mb-00 {
    font-size: 1.125rem;
    font-weight: 600;
    line-height: 1.4;
}
.hover-color:hover {
    color: #377dff;
}
.container >>> .el-pagination {
    padding-left: 0;
}
.container >>> .el-pagination button {
    margin-left: 0;
    margin-right: 0;
}
.container >>> .el-pagination .active {
    background-color: #377dff !important;
}
.hover-color:hover{
    color:#377dff;
}
</style>


// WEBPACK FOOTER //
// src/view/companyProduct.vue